/*
 * Franck Olivier — onglets best-sellers (WAI-ARIA tabs).
 * Bascule les panneaux et gère la navigation clavier. À l'affichage d'un panneau,
 * le <slider-component> Dawn qu'il contient se recalcule via son ResizeObserver ;
 * on déclenche aussi un resize par sécurité.
 */
class ProductTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    if (!this.tabs.length) return;

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activate(index));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });
  }

  activate(index, setFocus = true) {
    this.tabs.forEach((tab, i) => {
      const selected = i === index;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.setAttribute('tabindex', selected ? '0' : '-1');
      tab.classList.toggle('is-active', selected);
      if (this.panels[i]) this.panels[i].toggleAttribute('hidden', !selected);
    });
    if (setFocus) this.tabs[index].focus();
    // Aide au recalcul des carrousels du panneau devenu visible.
    window.dispatchEvent(new Event('resize'));
  }

  onKeydown(event, index) {
    const last = this.tabs.length - 1;
    let next = null;
    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        next = index === last ? 0 : index + 1;
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        next = index === 0 ? last : index - 1;
        break;
      case 'Home':
        next = 0;
        break;
      case 'End':
        next = last;
        break;
      default:
        return;
    }
    event.preventDefault();
    this.activate(next);
  }
}

if (!customElements.get('product-tabs')) {
  customElements.define('product-tabs', ProductTabs);
}
